import * as React from 'react';

import AppealText from '@/components/elements/AB/AppealText';
import RegisterButton from '@/components/elements/Button/RegisterButton';
import { useUserContext } from '@/contexts/user';
import { hasDmmLoginCookie } from '@/lib/auth';

import { Headline } from '../style';
import {
  AnchorButtonContainer,
  ArrowIcon,
  InputIcon,
  MailIcon,
  NoticeTextContainer,
  RegisterCompleteSpan,
  Step,
  StepList,
  StepTextContainer,
  UploadIcon,
  Wrapper,
} from './style';

const Index: React.FC = () => {
  const { isLoggedIn } = useUserContext();
  const noticeText = hasDmmLoginCookie() ? '利用登録' : 'DMM会員登録';

  return (
    <>
      <Headline>登録までの3ステップ</Headline>
      <Wrapper>
        <StepList>
          <Step stepNum={1} done={isLoggedIn}>
            <MailIcon isDone={isLoggedIn} />
            DMM会員登録
          </Step>
          <Step stepNum={2}>
            <InputIcon />
            情報入力
          </Step>
          <Step stepNum={3}>
            <UploadIcon />
            本人確認
          </Step>
        </StepList>
        <ArrowIcon />
        <StepTextContainer>
          <RegisterCompleteSpan>最短即日で登録完了！</RegisterCompleteSpan>
          <AppealText defaultText="DMM競輪 新規登録でtoreta+プレゼント！" />
        </StepTextContainer>
        <AnchorButtonContainer>
          <RegisterButton />
        </AnchorButtonContainer>
        <NoticeTextContainer>
          DMM競輪のご利用には
          <span>{noticeText}</span>
          が必要です
        </NoticeTextContainer>
        <NoticeTextContainer>
          ※
          toreta+を受け取るにはマイナンバーカードの電子証明を利用した本人確認もしくはSMS認証が必要です
        </NoticeTextContainer>
      </Wrapper>
    </>
  );
};

export default Index;
